import { formatString } from "@/helpers/formatting";
import { axiosClient } from "@/services/client";
import endpoints from "@/services/endpoints";

import type { TemplateViewParams } from "@/models/clients";
import type { IPaginatedResponse } from "@/models/common";
import type {
  CustomWebhook,
  CustomWebhookTriggerPayload,
} from "@/models/customWebhook";

class CustomWebhookService {
  async getCustomWebhooks(values: { payload: TemplateViewParams }) {
    const response = await axiosClient.get<IPaginatedResponse<CustomWebhook>>(
      endpoints.CLIENTS.CUSTOM_WEBHOOKS.ALL,
      {
        params: values.payload,
      }
    );
    return response.data;
  }

  async getCustomWebhook(id: string) {
    const response = await axiosClient.get<{ data: CustomWebhook }>(
      formatString(endpoints.CLIENTS.CUSTOM_WEBHOOKS.SINGLE, id)
    );
    return response.data.data;
  }

  async createCustomWebhook(values: { payload: Partial<CustomWebhook> }) {
    const response = await axiosClient.post<{ data: CustomWebhook }>(
      endpoints.CLIENTS.CUSTOM_WEBHOOKS.ALL,
      values.payload
    );
    return response.data.data;
  }

  async updateCustomWebhook(values: { payload: Partial<CustomWebhook> }) {
    if (!values.payload.id) {
      return;
    }
    const response = await axiosClient.put<{ data: CustomWebhook }>(
      formatString(endpoints.CLIENTS.CUSTOM_WEBHOOKS.SINGLE, values.payload.id),
      values.payload
    );
    return response.data.data;
  }

  async duplicateCustomWebhook(id: number | string) {
    const response = await axiosClient.post<{ data: CustomWebhook }>(
      formatString(endpoints.CLIENTS.CUSTOM_WEBHOOKS.DUPLICATE, id)
    );
    return response.data.data;
  }

  async deleteCustomWebhook(id: number | string) {
    const response = await axiosClient.delete<{ data: { deleted: boolean } }>(
      formatString(endpoints.CLIENTS.CUSTOM_WEBHOOKS.SINGLE, id)
    );
    return response;
  }

  async triggerCustomWebhooks(
    appIds: string[],
    webhooks: CustomWebhookTriggerPayload[]
  ) {
    await axiosClient.post(endpoints.CLIENTS.CUSTOM_WEBHOOKS.TRIGGER, {
      applications: appIds,
      webhooks,
    });
  }
}

const customWebhookService = new CustomWebhookService();
export default customWebhookService;
